import { useDispatch } from 'umi';





/**
 * initLoading 初始化loading
 * finishLoading 在请求完成后调用
 * resetLoading 重置loading
 * 
 *
 * @param props 
 * @returns 
 */
export function useSortLoading<T>(props?: {
  moduleKey?: string;
  keys?: Array<T>;
}) {
  const dispatch = useDispatch();
  const { moduleKey, keys = [] } = props || {};

  // 修复后的调用示例
  function finishLoading(key: T, localModuleKey = moduleKey) {
    if (localModuleKey) {
      dispatch({
        type: 'opinionCommonOrderLoading/changeLoading',
        payload: { moduleKey: localModuleKey, key },
      });
    }
  }

  function initLoading(moduleKeys: Array<string>) {
    if (keys?.length === 0) {
      console.error('必须要先设置keys,才能初始化loading');
      return;
    }
    dispatch({
      type: 'opinionCommonOrderLoading/initLoading',
      payload: {
        moduleKeys,
        keys,
      },
    });
  }

  function resetLoading() {
    dispatch({
      type: 'opinionCommonOrderLoading/resetLoading',
    });
  }

  return { finishLoading, initLoading, resetLoading };
}
